import axios, { AxiosError } from 'axios'
import { ActionWithPayload, AppDispatch } from '../store'

const UNSUBSCRIBE_REQUEST = 'UNSUBSCRIBE_REQUEST'
const UNSUBSCRIBE_SUCCESS = 'UNSUBSCRIBE_SUCCESS'
const UNSUBSCRIBE_ERROR = 'UNSUBSCRIBE_ERROR'
export const UNSUBSCRIBE_RESET = 'UNSUBSCRIBE_RESET'

interface UnsubscribeRequestAction {
  type: typeof UNSUBSCRIBE_REQUEST
}

interface UnsubscribeSuccessAction {
  type: typeof UNSUBSCRIBE_SUCCESS
  payload: boolean
}

interface UnsubscribeErrorAction {
  type: typeof UNSUBSCRIBE_ERROR
  payload: string
}

type UnsubscribeActionTypes =
  | UnsubscribeRequestAction
  | UnsubscribeSuccessAction
  | UnsubscribeErrorAction

export const unsubscribeUser =
  (email: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch({
        type: UNSUBSCRIBE_REQUEST,
      })

      const { data } = await axios.post(`/api/users/unsubscribe/`, { email })

      return dispatch({
        type: UNSUBSCRIBE_SUCCESS,
        payload: data,
      })
    } catch (err) {
      const error = err as AxiosError

      return dispatch({
        type: UNSUBSCRIBE_ERROR,
        payload: error.message,
      })
    }
  }

interface InitialState {
  error: string
  loading: boolean
  success: boolean
}

const initialState: InitialState = {
  error: '',
  loading: false,
  success: false,
}

export const unsubscribeReducer = (
  state = initialState,
  action: ActionWithPayload<UnsubscribeActionTypes>
) => {
  switch (action.type) {
    case UNSUBSCRIBE_REQUEST:
      return {
        ...state,
        error: '',
        loading: true,
        success: false,
      }
    case UNSUBSCRIBE_SUCCESS:
      return {
        ...state,
        error: '',
        success: true,
        loading: false,
      }
    case UNSUBSCRIBE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        success: false,
      }
    case UNSUBSCRIBE_RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
